import { RagDocumentCard, type RagDocumentCardItem } from "./RagDocumentCard.js";
import type { RagDocumentActionCallbacks } from "./RagDocumentActions.js";

interface RagDocumentsGridProps extends RagDocumentActionCallbacks {
  documents: RagDocumentCardItem[];
  onDetails?: (documentId: string) => void;
}

export function RagDocumentsGrid({
  documents,
  onView,
  onReprocess,
  onDelete,
  onStatus,
  onDetails,
}: RagDocumentsGridProps) {
  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(148px,1fr))] gap-2.5">
      {documents.map((doc) => (
        <RagDocumentCard
          key={doc.id}
          document={doc}
          onView={onView}
          onReprocess={onReprocess}
          onDelete={onDelete}
          onStatus={onStatus}
          onDetails={onDetails}
        />
      ))}
    </div>
  );
}
